import { render } from "./UserUploadContent.vue?vue&type=template&id=1d66b0c0"
import script from "./UserUploadContent.vue?vue&type=script&lang=js"
export * from "./UserUploadContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__